export const showNotificationError = (instance, title, erroMsg) => {
  const h = instance.$createElement;
  instance.$error({
    title: title === null ? "Ops! Ocorreu um erro." : title,
    content: h("div", {}, [h("p", erroMsg)]),
    zIndex: 9999999,
    onOk() { }
  });
};

export const showNotificationSucess = (instance, title, msg) => {
  const h = instance.$createElement;
  instance.$success({
    title: title,
    content: h("div", {}, [h("p", msg)]),
    zIndex: 9999999,
    onOk() { }
  });
};

export const showNotificationSucessPreFormatado = (instance, title, msg) => {
  const h = instance.$createElement;
  instance.$success({
    title: title,
    content: h("pre", {}, [h("p", msg)]),
    zIndex: 9999999,
    onOk() { }
  });
};